const formatEur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

const plural = (n) => (n > 1 ? "s" : "");

/** Signale les avoirs qui ne réduisent PAS le reste dû : brouillons et remboursements. */
export const AvoirPendingNotes = ({ doc, suffix = "" }) => (
  <>
    {(doc.avoir_draft_count || 0) > 0 && (
      <div
        className="text-[10px] text-amber-600"
        title={`Avoir(s) en brouillon : ${(doc.avoir_draft_numbers || []).join(", ")}`}
        data-testid={`avoir-draft-note${suffix}-${doc.id}`}
      >
        {doc.avoir_draft_count} avoir{plural(doc.avoir_draft_count)} en brouillon ({formatEur(doc.avoir_draft_ttc || 0)}) — non imputé{plural(doc.avoir_draft_count)}
      </div>
    )}
    {(doc.avoir_refund_count || 0) > 0 && (
      <div
        className="text-[10px] text-slate-500"
        title={`Avoir(s) en remboursement : ${(doc.avoir_refund_numbers || []).join(", ")}`}
        data-testid={`avoir-refund-note${suffix}-${doc.id}`}
      >
        Avoir en remboursement ({formatEur(doc.avoir_refund_ttc || 0)}) — non imputé sur cette facture
      </div>
    )}
  </>
);

/** Pastille ambre : des avoirs visent la facture sans l'imputer (brouillon ou remboursement). */
export const AvoirPendingBadge = ({ doc }) => {
  const drafts = doc.avoir_draft_count || 0;
  const refunds = doc.avoir_refund_count || 0;
  if (!drafts && !refunds) return null;
  const infos = [
    drafts ? `${drafts} avoir${plural(drafts)} en brouillon (${formatEur(doc.avoir_draft_ttc || 0)}) — non imputé${plural(drafts)} : ${(doc.avoir_draft_numbers || []).join(", ")}` : null,
    refunds ? `Avoir en remboursement (${formatEur(doc.avoir_refund_ttc || 0)}) — non imputé sur cette facture : ${(doc.avoir_refund_numbers || []).join(", ")}` : null,
  ].filter(Boolean).join("\n");
  return (
    <span
      className="inline-flex h-4 min-w-4 items-center justify-center rounded-full bg-amber-100 px-1 text-[9px] font-bold text-amber-700 ring-1 ring-amber-300 cursor-help"
      title={infos}
      data-testid={`avoir-pending-badge-${doc.id}`}
    >
      {drafts + refunds}
    </span>
  );
};

/** Bandeau affiché sur un avoir tant qu'il n'est pas émis. */
export const AvoirDraftBanner = ({ doc }) => {
  if (!doc || doc.type !== "avoir" || (doc.status || "brouillon") !== "brouillon") return null;
  const cible = doc.source_doc_number ? `la facture ${doc.source_doc_number}` : "la facture visée";
  return (
    <div
      className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-[12px] text-amber-800"
      data-testid={`avoir-draft-banner-${doc.id || "new"}`}
    >
      Cet avoir n&apos;est pas encore émis : il ne réduit pas encore le solde de {cible}.
    </div>
  );
};
